import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { Button } from "../components/ui/button";

import onboarding1 from "../../../assets/onboarding-1.png";
import onboarding2 from "../../../assets/onboarding-2.png";
import onboarding2Small from "../../../assets/onboarding-2(1).png";
import onboarding3 from "../../../assets/onboarding-3.png";
import { ChevronLeft, ChevronRight } from "lucide-react";

function PageOne() {
	return (
		<div className="h-full overflow-hidden">
			<div className="h-1/2 bg-sky-100 grid justify-center pt-9 overflow-hidden">
				<img src={onboarding1} width={240} />
			</div>
			<div className="h-1/2">
				<div className="max-w-60 text-center mx-auto mt-9 flex flex-col gap-4">
					<h1 className="font-bold text-xl">Identify and Redline Risks</h1>
					<p className="text-sm font-normal">
						LegalGraph AI quickly identifies potential risks and non-standard language in your contracts.
					</p>
				</div>
			</div>
		</div>
	);
}

function PageTwo() {
	return (
		<div className="h-full overflow-hidden">
			<div className="h-1/2 bg-sky-100 grid justify-center pt-9 overflow-hidden">
				<img src={onboarding2} width={240} />
				<img src={onboarding2Small} width={200} className="absolute right-1/12 top-[35%]" />
			</div>
			<div className="h-1/2">
				<div className="max-w-60 text-center mx-auto mt-9 flex flex-col gap-4">
					<h1 className="font-bold text-xl text-center max-w-60">Manage Playbooks</h1>
					<p className="text-sm font-normal">
						Use our collection of professionally designed playbooks to standardize contract terms or upload your own to
						define your company's standards.
					</p>
				</div>
			</div>
		</div>
	);
}

function PageThree({ endOnboarding }) {
	return (
		<div className="h-full overflow-hidden">
			<div className="h-1/2 bg-sky-100 grid justify-center pt-9 overflow-hidden">
				<img src={onboarding3} width={240} />
			</div>
			<div className="h-1/2">
				<div className="max-w-60 text-center mx-auto mt-9 flex flex-col gap-4">
					<h1 className="font-bold text-xl text-center max-w-60">AI Reasoning</h1>
					<p className="text-sm font-normal">
						Click the 'AI Reasoning' icon to understand why a clause was flagged and the AI's rationale behind the
						suggested resolution.
					</p>

					<Button onClick={endOnboarding}>Get Started</Button>
				</div>
			</div>
		</div>
	);
}

function Onboarding() {
	const navigate = useNavigate();

	const [activeStep, setActiveStep] = useState(0);

	function handleNext() {
		setActiveStep((prev) => prev + 1);
	}

	function handlePrev() {
		setActiveStep((prev) => prev - 1);
	}

	function endOnboarding() {
		localStorage.setItem("onBoardingCompleted", "true");
		navigate("/");
	}

	const steps = [PageOne(), PageTwo(), PageThree({ endOnboarding })];
	const NUM_STEPS = steps.length - 1;

	return (
		<div className="flex flex-col h-screen">
			<div className="flex justify-between items-center px-3 py-2">
				<p className="text-sm font-bold text-primary">LegalGraph AI</p>
				<Button variant="link" className="text-sm font-normal" onClick={endOnboarding}>
					Skip
				</Button>
			</div>
			<Button size="sm" className="w-8 absolute left-2 top-2/5 z-10" onClick={handlePrev} disabled={activeStep == 0}>
				<ChevronLeft />
			</Button>
			<Button
				size="sm"
				className="w-8 absolute right-2 top-2/5 z-10"
				onClick={handleNext}
				disabled={activeStep == NUM_STEPS}
			>
				<ChevronRight />
			</Button>
			{steps[activeStep]}
		</div>
	);
}

export { Onboarding };
